/**
 * Search input component for filtering articles
 */

'use client';

interface FilterSearchProps {
  query: string;
  onQueryChange: (query: string) => void;
  placeholder?: string;
}

export function FilterSearch({
  query,
  onQueryChange,
  placeholder = 'Search articles...',
}: FilterSearchProps) {
  return (
    <div className="w-full">
      <label htmlFor="article-search" className="sr-only">
        Search articles
      </label>
      <input
        id="article-search"
        type="search"
        value={query}
        placeholder={placeholder}
        onChange={event => onQueryChange(event.target.value)}
        autoComplete="off"
        className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
      />
    </div>
  );
}

